import { render, staticRenderFns } from "./EducationalStatusModal.vue?vue&type=template&id=569483da&scoped=true"
import script from "./EducationalStatusModal.vue?vue&type=script&lang=js"
export * from "./EducationalStatusModal.vue?vue&type=script&lang=js"
import style0 from "./EducationalStatusModal.vue?vue&type=style&index=0&id=569483da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569483da",
  null
  
)

export default component.exports